var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "feed-empty"
  }, [_c('div', {
    staticClass: "feed-empty-left"
  }), _c('div', {
    staticClass: "feed-empty-text"
  }, [_vm._v("已经到底了！推荐你可能喜欢的内容")]), _c('div', {
    staticClass: "feed-empty-right"
  })]);
}];
export { render, staticRenderFns };